const text = (value) => String(value ?? "").trim();

// Mirror /app-list: managed documents belong to their base app.
export const findAppUpdateCandidates = (releaseApps, projects) => {
  const configuredAppIds = new Set(projects.flatMap((project) =>
    (project.apps || []).map((app) => text(app.platforms?.android?.sourceId)).filter(Boolean)
  ));

  return releaseApps
    .filter((app) => !app.id.endsWith("-managed"))
    .map((app) => ({ ...app, sourceId: text(app.appId) }))
    .filter((app) => app.sourceId && !configuredAppIds.has(app.sourceId))
    .sort((a, b) => text(a.appName || a.id).localeCompare(text(b.appName || b.id)));
};
